import { Component } from "@angular/core";
import { ActivatedRoute,Router } from "@angular/router";
import { Department } from "@enums/department.enum";
import { IdType } from "@enums/idType.enum";
import { Shift } from "@enums/shift.enum";
import { TrainingStatus } from "@enums/trainingStatus.enum";
import { environment } from "@environments/environment";
import { CheckGroupPermissions } from "@helpers/checkGroupPermissions";
import { MACHINE_TIME_LEGEND, MACHINE_TIME_TICKS, MachineTimeBars, MachineTimeClock, MachineTimeSummary } from "@helpers/machineTime";
import { AddMonths, FirstDayOfMonth, LastDayOfMonth } from "@helpers/dateHelper";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { ConfirmPendingTraining } from "@interfaces/confirmPendingTraining.interface";
import { AdminCreateFullAttendanceDto } from "@interfaces/dto/adminCreateFullAttendanceDto.interface";
import { FobScannedDto } from "@interfaces/dto/fobScannedDto.interface";
import { Group } from "@interfaces/group.interface";
import { HeatMapDayData } from "@interfaces/heatMapDayData.interface";
import { Machine } from "@interfaces/models/machine.interface";
import { Site } from "@interfaces/site.interface";
import { Skill } from "@interfaces/skill.interface";
import { StaffAttendance } from "@interfaces/staffAttendance.interface";
import { TimeReportForUser } from "@interfaces/timeReportForUser.interface";
import { Training } from "@interfaces/training.interface";
import { UserLoginCountryBypass } from "@interfaces/userLoginCountryBypass.interface";
import { UserProfile } from "@interfaces/userProfile.interface";
import { AppSettingsService } from "@services/appSettings.service";
import { AuthService } from "@services/auth.service";
import { FileService } from "@services/file.service";
import { GroupService } from "@services/group.service";
import { HolidaySettingsService } from "@services/holidaySettings.service";
import { MachineService } from "@services/machine.service";
import { MachineQuestionnaireService } from "@services/machineQuestionnaire.service";
import { OpsActionAuditService } from "@services/opsActionAudit.service";
import { SiteService } from "@services/site.service";
import { SkillService } from "@services/skillService.service";
import { StaffAttendanceService } from "@services/staffAttendance.service";
import { TrainingService } from "@services/trainingService.service";
import { UserService } from "@services/user.service";
import { UserLoginCountryBypassService } from "@services/userLoginCountryBypass.service";
import { UserProfileService } from "@services/userProfile.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "userProfiles-id",
	styleUrls: ["userProfiles-id.css"],
	templateUrl: "userProfiles-id.html"
})
export class UserProfilesIdAdminComponent {
	attendance: StaffAttendance[] = [];
	avatarStyle = "";
	confirmTrainingLevels = [1, 2, 3, 4];
	createEnabled = true;
	currentlyAtSite = "";
	departments: any;
	disableEmailAddress = true;
	editEnabled = true;
	fullName = "";
	genders = ["Male","Female","Other"];
	groups: Group[] = [];
	headerPrimaryButtons: AdminHeaderButton[] = [];
	headerSecondaryButtons: AdminHeaderButton[] = [];
	headerTertiaryButtons: AdminHeaderButton[] = [];
	heatMapDayData: HeatMapDayData[] = [];
	heatMapFromDate: Date = new Date;
	heatMapToDate: Date = new Date;
	holidayAllowanceReadOnly = true;
	idTypes: any;
	isExecutive = false;
	isSuperAdmin = false;
	isTimeManagement = false;
	item: UserProfile = new UserProfile();
	itemType = "User";
	loginBypasses: UserLoginCountryBypass[] = [];
	machineQuestionnaires: any;
	machineTimeDate: string | number | Date = new Date();
	machineTimeDays = 7;
	machineTimeDaysData: any[] = [];
	machineTimeLegend = MACHINE_TIME_LEGEND;
	machineTimeSpans = [{ id: 1, name: "This day" }, { id: 7, name: "Last 7 days" }, { id: 14, name: "Last 14 days" }];
	machineTimeTicks = MACHINE_TIME_TICKS;
	machineTimeTip: any = null;
	machineTimeUnreadable = 0;
	machines: Machine[] = [];
	mode = "";
	opsActionAuditsOperator: any;
	opsActionAuditsUser: any;
	popupAddButtonOptions: any = { onClick: () => this.createTraining(), text: "Add Training" };
	popupAdminCreateFullAttendanceDto: AdminCreateFullAttendanceDto = new AdminCreateFullAttendanceDto();
	popupCloseButtonOptions: any = { onClick: () => this.closePopup(), text: "Close" };
	popupConfirmPendingTraining: ConfirmPendingTraining = new ConfirmPendingTraining();
	popupFobScanned: FobScannedDto = new FobScannedDto();
	popupTimeReportParameters: TimeReportForUser = new TimeReportForUser();
	popupTitle = "Add New Training";
	popupTraining: Training = new Training();
	popupUserLoginCountryBypass: UserLoginCountryBypass = new UserLoginCountryBypass();
	popupVisible = false;
	readOnly = true;
	returnUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	shifts: any;
	sites: Site[] = [];
	skills: Skill[] = [];
	supervisors: any;
	timeReport: any;
	title: string = "View " + this.itemType;
	titles: string[] = [];
	today = new Date();
	training: Training[] = [];
	trainingLevels = [0, 1, 2, 3, 4];
	trainingStatuses: any;
	userGroups: Group[] = [];

	constructor(private router:Router, private toastService: ToastService, private route: ActivatedRoute, private appSettingsService: AppSettingsService, private authService: AuthService, private fileService: FileService, private groupService: GroupService, private holidaySettingsService: HolidaySettingsService, private machineService: MachineService, private machineQuestionnaireService: MachineQuestionnaireService, private opsActionAuditService: OpsActionAuditService, private siteService: SiteService, private skillService: SkillService, private staffAttendanceService: StaffAttendanceService, private trainingService: TrainingService, private userService: UserService, private userLoginCountryBypassService: UserLoginCountryBypassService, private itemService: UserProfileService) {
		this.isSuperAdmin = CheckGroupPermissions(appSettingsService, "Super Admin");
		this.isTimeManagement = CheckGroupPermissions(appSettingsService, "Time Management");
		this.isExecutive = CheckGroupPermissions(appSettingsService, "Executive");
		this.editAttendanceRow = this.editAttendanceRow.bind(this);
		this.departments = GetPropertiesFromEnum(Department);
		this.idTypes = GetPropertiesFromEnum(IdType);
		this.shifts = GetPropertiesFromEnum(Shift);
		this.trainingStatuses = GetPropertiesFromEnum(TrainingStatus);
		this.getDefaultHolidayEditingPermission();
		this.getSupervisors();
		this.getTitles();
		this.getMachines();
		this.getSites();
		this.getSkills();
		this.confirmTrainingPopup = this.confirmTrainingPopup.bind(this);
		this.deleteTraining = this.deleteTraining.bind(this);
		this.deleteUserLoginCountryBypass = this.deleteUserLoginCountryBypass.bind(this);
		this.downloadCertificate = this.downloadCertificate.bind(this);
		this.editUserLoginCountryBypassPopup = this.editUserLoginCountryBypassPopup.bind(this);
		this.toggleUserGroup = this.toggleUserGroup.bind(this);
		this.uploadProfileImage = this.uploadProfileImage.bind(this);
		this.route.params
			.subscribe((params) => {
				if (params.id != "create") {
					if (params.id.split("_").length > 1) {
						this.getItem(params.id.split("_")[0], "edit");
						this.edit();
					} else {
						this.getItem(params.id, "view");
					}
				} else {
					this.create();
				}
			});
	}

	activate() {
		if (confirm("Are you sure you with to activate this account?") === false) {
			return;
		}
		this.itemService.activate(this.item.id)
			.subscribe(
				() => {
					this.toastService.success("Successfully Activated " + this.itemType);
					this.getItem(this.item.id, this.mode);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	addTrainingPopup() {
		this.popupTraining = new Training();
		this.popupAddButtonOptions = { onClick: () => this.createTraining(), text: "Add Training" };
		this.popupCloseButtonOptions = { onClick: () => this.closePopup(), text: "Close" };
		this.popupTitle = "Add New Training";
		this.popupVisible = true;
	}

	addUserLoginCountryBypass() {
		this.userLoginCountryBypassService.createSingle(this.popupUserLoginCountryBypass)
			.subscribe(
				() => {
					this.toastService.success("Successfully Added New Login Bypass");
					this.getUserLoginCountryBypasses();
					this.closePopup();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	addUserLoginCountryBypassPopup() {
		this.popupUserLoginCountryBypass = new UserLoginCountryBypass();
		this.popupUserLoginCountryBypass.userId = this.item.userId;
		this.popupUserLoginCountryBypass.startDate = new Date();
		this.popupUserLoginCountryBypass.endDate = new Date();
		this.popupAddButtonOptions = { onClick: () => this.addUserLoginCountryBypass(), text: "Add Bypass" };
		this.popupCloseButtonOptions = { onClick: () => this.closePopup(), text: "Close" };
		this.popupTitle = "Add New Login Bypass";
		this.popupVisible = true;
	}

	adminCreateFullAttendance() {
		if (this.isSuperAdmin == false && this.isTimeManagement == false) {
			alert("You do not have permission to perform this action.");
			return;
		}
		if (this.popupAdminCreateFullAttendanceDto.startDate === undefined || this.popupAdminCreateFullAttendanceDto.endDate === undefined || this.popupAdminCreateFullAttendanceDto.endDate <= this.popupAdminCreateFullAttendanceDto.startDate) {
			alert("Please ensure you enter both the start and end date, and the end date is later.");
			return;
		}
		this.staffAttendanceService.adminCreateFullAttendance(this.popupAdminCreateFullAttendanceDto)
			.subscribe(
				() => {
					this.toastService.success("Added Attendance Successfully!");
					this.closePopup();
					this.getHeatMap();
					this.getAttendance(this.item.id);
				},
				(err) => {
					this.toastService.error("Something Went Wrong!");
					console.log(err);
				}
			);
	}

	adminCreateFullAttendancePopup() {
		if (this.isSuperAdmin == false && this.isTimeManagement == false) {
			alert("You do not have permission to perform this action.");
			return;
		}
		this.popupAdminCreateFullAttendanceDto = new AdminCreateFullAttendanceDto();
		this.popupAdminCreateFullAttendanceDto.staffMemberId = this.item.id;
		this.popupAdminCreateFullAttendanceDto.siteId = this.item.siteId;
		this.popupAddButtonOptions = { onClick: () => this.adminCreateFullAttendance(), text: "Add Attendance" };
		this.popupCloseButtonOptions = { onClick: () => this.closePopup(), text: "Close" };
		this.popupTitle = "Add Attendance";
		this.popupVisible = true;
	}

	boolYesNo(cellInfo: any) {		
		if(cellInfo.value === true)
		{
			return "YES";
		}
		else
		{
			return "NO";
		}
	}

	buildButtons(mode: string) {
		this.mode = mode;
		this.headerPrimaryButtons = [];
		this.headerSecondaryButtons = [];
		this.headerTertiaryButtons = [];
		if (mode == "edit" && this.editEnabled) {
			this.headerPrimaryButtons = [
				{ method: "updateItem", text: "Save Changes" },
				{ method: "cancelEditing", text: "View Mode" },
				{ method: "close", text: "Close" }
			];
			this.headerTertiaryButtons = [			
				{ method: "addTrainingPopup", text: "Add Training" }
			];
		} else if (mode == "create" && this.createEnabled) {
			this.headerPrimaryButtons = [
				{ method: "createItem", text: "Save" },
				{ method: "close", text: "Close" }
			];
			this.headerTertiaryButtons = [];
		} else if (mode == "view") {
			this.headerPrimaryButtons = [
				{ method: "edit", text: "Edit" },
				{ method: "close", text: "Close" }
			];
			this.headerTertiaryButtons = [
				{ method: "addTrainingPopup", text: "Add Training" },
				{ method: "addUserLoginCountryBypassPopup", text: "Add Login Bypass" },
				{ method: "updateTimeReportPopup", text: "Update Time Report" }
			];
			if (this.isSuperAdmin) {
				if (this.item.isActive === true)
				{
					this.headerSecondaryButtons = [{ method: "deactivate", text: "Deactivate" }];
				}
				else
				{
					this.headerSecondaryButtons = [{ method: "activate", text: "Activate" }];
				}
			}
			if (this.isTimeManagement) {
				this.headerSecondaryButtons.push({ method: "fobScannedPopup", text: "Manual Fob Scan" });
			}
			if (this.isTimeManagement || this.isSuperAdmin) {
				this.headerSecondaryButtons.push({ method: "adminCreateFullAttendancePopup", text: "Add Attendance" });
				this.headerSecondaryButtons.push({ method: "viewBadgeIdPopup", text: "Badge ID" });
			}
		}
	}

	cancelEditing() {
		if (confirm("Are you sure you wish to switch modes? Unsaved changes will be discarded.") == false) {
			return;
		}
		this.readOnly = true;
		this.buildButtons("view");
		this.title = "View " + this.itemType;
	}

	close() {
		this.router.navigate([`/${this.returnUrl}/`]);
	}
	
	closePopup() {
		this.popupVisible = false;
	}

	confirmTraining() {
		this.trainingService.confirmPending(this.popupConfirmPendingTraining)
			.subscribe(
				() => {
					this.toastService.success("Successfully Confirmed Training");
					this.getTraining(this.item.id);
					this.closePopup();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	confirmTrainingPopup(e: any) {
		this.popupConfirmPendingTraining = new ConfirmPendingTraining();
		this.popupConfirmPendingTraining.trainingDate = e.row.data.trainingDate;
		this.popupConfirmPendingTraining.trainingId = e.row.data.id;
		this.popupConfirmPendingTraining.level = e.row.data.level;
		this.popupAddButtonOptions = { onClick: () => this.confirmTraining(), text: "Confirm Training" };
		this.popupCloseButtonOptions = { onClick: () => this.closePopup(), text: "Close" };
		this.popupTitle = "Confirm Training";
		this.popupVisible = true;
	}

	copyBadgeId() {
		navigator.clipboard.writeText(this.item.lookupId.toString());
		this.closePopup();
		this.toastService.info("Copied Badge ID to Clipboard");
	}

	create() {
		this.holidaySettingsService.getSettings()
			.subscribe(
				(res: any) => {
					const holidaySettings = res.response;
					this.item.defaultHolidayAllowance = holidaySettings.defaultHolidayAllowance;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
		this.disableEmailAddress = false;
		this.readOnly = false;
		this.buildButtons("create");
		this.title = "Create New " + this.itemType;
	}

	createItem() {
		this.itemService.adminCreate(this.item)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated " + this.itemType);
					this.item = new UserProfile();
					this.close();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	createTraining() {
		this.popupTraining.userProfileId = this.item.id;
		this.popupTraining.trainingStatus = TrainingStatus.Trained;
		this.trainingService.createSingle(this.popupTraining)
			.subscribe(
				() => {
					this.toastService.success("Successfully Added New Training");
					this.getTraining(this.item.id);
					this.closePopup();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	deactivate() {
		if (confirm("Are you sure you with to deactivate this account?") === false) {
			return;
		}
		this.itemService.deactivate(this.item.id)
			.subscribe(
				() => {
					this.toastService.success("Successfully Deactivated " + this.itemType);
					this.getItem(this.item.id, this.mode);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	deleteTraining(e: any) {
		if (confirm("Are you sure you with to delete this training?") == false) {
			return;
		}
		this.trainingService.deleteSingleById(e.row.data.id)
			.subscribe(
				() => {
					this.toastService.success("Successfully Removed Training");
					this.getTraining(this.item.id);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	deleteUserLoginCountryBypass(e: any) {
		if (confirm("Are you sure you with to delete this login bypass?") == false) {
			return;
		}
		this.userLoginCountryBypassService.deleteSingleById(e.row.data.id)
			.subscribe(
				() => {
					this.toastService.success("Successfully Removed Login Bypass");
					this.getUserLoginCountryBypasses();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	displayMachineInDropdown(e: any) { 
		return e === null || e === undefined ? "" : (e.cellNumber === null || e.cellNumber === undefined ? "???" : e.cellNumber) + " - " + e.name;
	}

	downloadCertificate(e: any) {		
		this.trainingService.downloadCertificate(e.row.data.id).subscribe(
			(response: any) =>{
				const dataType = response.type;
				const binaryData = [];
				binaryData.push(response);
				const downloadLink = document.createElement("a");
				downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
				downloadLink.setAttribute("download", "Training_Certificate.pdf");
				document.body.appendChild(downloadLink);
				downloadLink.click();
			}
		);
	}

	// The days on screen, as a PDF to print or send on.
	downloadMachineTimePdf() {
		if (!this.item?.id || !this.isSuperAdmin) return;
		const date = new Date(this.machineTimeDate || new Date());
		this.itemService.machineTimePdf(this.item.id, date, this.machineTimeDays)
			.subscribe(
				(res: any) => {
					const link = document.createElement("a");
					link.href = window.URL.createObjectURL(new Blob([res], { type: "application/pdf" }));
					link.setAttribute("download", `MachineTime_${(this.item.fullName || "employee").replace(/\s+/g, "")}_${date.toISOString().slice(0, 10)}.pdf`);
					document.body.appendChild(link);
					link.click();
					link.remove();
				},
				(err) => { console.log(err); this.toastService.error("Could not build the PDF."); }
			);
	}

	edit() {
		this.disableEmailAddress = true;
		this.readOnly = false;
		this.buildButtons("edit");
		this.title = "Edit " + this.itemType;
		this.toastService.warn("You are now editing...");
	}

	editAttendanceRow(e: any) {
		e.component.editRow(e.row.rowIndex);
	}

	editUserLoginCountryBypass() {
		this.userLoginCountryBypassService.updateSingleById(this.popupUserLoginCountryBypass.id, this.popupUserLoginCountryBypass)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated Login Bypass");
					this.getUserLoginCountryBypasses();
					this.closePopup();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	editUserLoginCountryBypassPopup(e: any) {
		this.userLoginCountryBypassService.getSingleById(e.row.data.id)
			.subscribe(
				(res: any) => {
					this.popupUserLoginCountryBypass = res.response;
					this.popupTitle = "Edit Login Bypass";
					this.popupVisible = true;
					this.popupAddButtonOptions = { onClick: () => this.editUserLoginCountryBypass(), text: "Save Changes" };
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	fobScanned() {
		if (this.isTimeManagement == false) {
			alert("You do not have permission to perform this action.");
			return;
		}
		this.staffAttendanceService.adminFobScanned(this.popupFobScanned)
			.subscribe(
				() => {
					this.toastService.success("Fob Scanned Successfully!");
					this.closePopup();
					this.getHeatMap();
					this.getAttendance(this.item.id);
				},
				(err) => {
					this.toastService.error("Something Went Wrong!");
					console.log(err);
				}
			);
	}

	fobScannedPopup() {
		if (this.isTimeManagement == false) {
			alert("You do not have permission to perform this action.");
			return;
		}
		this.popupFobScanned = new FobScannedDto();
		this.popupFobScanned.fobId = this.item.fobId;
		this.popupFobScanned.siteId = this.item.siteId;
		this.popupAddButtonOptions = { onClick: () => this.fobScanned(), text: "Add Fob Scan" };
		this.popupCloseButtonOptions = { onClick: () => this.closePopup(), text: "Close" };
		this.popupTitle = "Add Fob Scan";
		this.popupVisible = true;
	}

	getAttendance(id: number) {
		this.staffAttendanceService.forUserProfile(id)
			.subscribe(
				(res: any) => this.attendance = res.response,
				(err) => {console.log(err); this.toastService.error("Something Went Wrong!");}
			);
	}

	getDefaultHolidayEditingPermission() {		
		this.holidaySettingsService.canEditDefaultAllowance()
			.subscribe(
				(res: any) => {
					const canEdit = res.response;
					this.holidayAllowanceReadOnly = canEdit === false;
				},
				(err) => console.log(err)
			);
	}

	getGroups() {
		this.groupService.getAll()
			.subscribe(
				(res: any) => {
					this.groups = res.response.items;
					this.groups.forEach((group) => { group.isSelected = false; });
					this.getUserGroups();
				},
				(err) => console.log(err)
			);
	}

	getHeatMap() {
		const today = new Date;
		this.heatMapFromDate = FirstDayOfMonth(AddMonths(today, -11));
		this.heatMapToDate = LastDayOfMonth(today);
		this.staffAttendanceService.heatMapForUserProfile(this.item.id, this.heatMapFromDate, this.heatMapToDate)
			.subscribe(
				(res: any) => this.heatMapDayData = res.response,
				(err) => console.log(err)
			);
	}

	getItem(itemId: number, mode: string) {
		this.itemService.getSingleById(itemId)
			.subscribe(
				(res: any) => {
					this.item = res.response;
					this.fullName = res.response.fullName;
					this.setAvatarStyle(this.item.profileImage);
					this.getAttendance(this.item.id);
					this.getOpenSession(this.item.id);
					this.getTraining(this.item.id);
					this.getGroups();
					if (this.isSuperAdmin) {
						this.getMachineTime();
					}
					this.getOpsActionAuditsOperator(itemId);
					this.getOpsActionAuditsUser(itemId);
					this.getQuestionnaires();
					this.getUserLoginCountryBypasses();
					this.getHeatMap();

					this.popupTimeReportParameters.userProfileId = this.item.id;
					this.popupTimeReportParameters.endDate = new Date;
					this.popupTimeReportParameters.startDate = new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000));
					this.getTimeReport();

					this.buildButtons(mode);
				},
				(err) => {console.log(err); this.toastService.error("Something Went Wrong!");}
			);
	}

	// The employee's machine statuses for the chosen days, laid out against the fixed window the API uses.
	getMachineTime() {
		if (!this.item?.id || !this.isSuperAdmin) return;
		this.itemService.machineTime(this.item.id, new Date(this.machineTimeDate || new Date()), this.machineTimeDays)
			.subscribe(
				(res: any) => {
					const days = res.response || [];
					// Oldest first, the way the API returns them and the way the PDF prints them, so a week reads
					// Monday down to Sunday rather than backwards.
					this.machineTimeDaysData = days
						.map((day: any) => ({ ...day, bars: MachineTimeBars(day), clock: MachineTimeClock(day), summary: MachineTimeSummary(day) }));
				},
				(err) => { console.log(err); this.toastService.error("Could not load machine time."); }
			);
	}

	getMachines() {		
		this.machineService.getAll()
			.subscribe(
				(res: any) => this.machines = res.response.items,
				(err) => console.log(err)
			);
	}

	getOpenSession(id: number) {
		this.staffAttendanceService.openSessionForUserProfile(id)
			.subscribe(
				(res: any) => {
					if (res.response !== null) {
						this.currentlyAtSite = res.response.site.name;
					}
				},
				(err) => {console.log(err); this.toastService.error("Something Went Wrong!");}
			);
	}

	getOpsActionAuditsOperator(operatorId: number)	{
		this.opsActionAuditService.getByOperatorId(operatorId)
			.subscribe(
				(res: any) => {
					this.opsActionAuditsOperator = res.response;
				},
				(err) => console.log(err)
			);
	}

	getOpsActionAuditsUser(userProfileId: number)	{
		this.opsActionAuditService.getByUserProfileId(userProfileId)
			.subscribe(
				(res: any) => {
					this.opsActionAuditsUser = res.response;
				},
				(err) => console.log(err)
			);
	}

	getQuestionnaires() {
		this.machineQuestionnaireService.getByUserProfileId(this.item.id)
			.subscribe(
				(res: any) => this.machineQuestionnaires = res.response,
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	getSites() {		
		this.siteService.getAll()
			.subscribe(
				(res: any) => this.sites = res.response.items,
				(err) => console.log(err)
			);
	}

	getSkills() {		
		this.skillService.getAll()
			.subscribe(
				(res: any) => this.skills = res.response.items,
				(err) => console.log(err)
			);
	}

	getSupervisors() {		
		this.itemService.getSupervisors()
			.subscribe(
				(res: any) => this.supervisors = res.response,
				(err) => console.log(err)
			);
	}

	getTimeReport() {
		this.staffAttendanceService.timeReportForUser(this.popupTimeReportParameters)
			.subscribe(
				(res: any) => this.timeReport = res.response,
				(err) => console.log(err)
			);
	}

	getTitles() {
		this.authService.getTitles()
			.subscribe(
				(res: any) => this.titles = res.response,
				(err) => console.log(err)
			);
	}

	getTraining(id: number) {
		this.trainingService.getTrainingForUserProfileId(id)
			.subscribe(
				(res: any) => this.training = res.response,
				(err) => {console.log(err); this.toastService.error("Something Went Wrong!");}
			);
	}

	getUserGroups() {		
		this.userService.groupsForUser(this.item.userId)
			.subscribe(
				(res: any) => {
					this.userGroups = res.response;
					this.userGroups.forEach((userGroup) => {
						const index = this.groups.findIndex((g => g.id === userGroup.id));
						this.groups[index].isSelected = true;
					});
				},
				(err) => console.log(err)
			);
	}

	getUserLoginCountryBypasses() {		
		this.userLoginCountryBypassService.getByUserId(this.item.userId)
			.subscribe(
				(res: any) => {
					this.loginBypasses = res.response;
				},
				(err) => console.log(err)
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	hideMachineTimeTip() {
		this.machineTimeTip = null;
	}

	isConfirmTrainingAvailable(e: any) {
		return e.row.data.trainingStatus === TrainingStatus.Pending;
	}

	isDownloadTrainingAvailable(e: any) {
		return e.row.data.trainingStatus !== TrainingStatus.Pending;
	}

	isToggleGroupOffVisible(e: any) {
		return e.row.data.isSelected === true;
	}

	isToggleGroupOnVisible(e: any) {
		return e.row.data.isSelected === false;
	}


	onAttendanceSaving(e: any) {
		e.cancel = true;
		for (const change of e.changes) {
			if (change.type !== "update") continue;
			const original = this.attendance.find((a: any) => a.id === change.key);
			if (!original) continue;
			const startDate = change.data.startDate !== undefined ? new Date(change.data.startDate) : new Date(original.startDate);
			const endDate = change.data.endDate !== undefined ? new Date(change.data.endDate) : (original.endDate ? new Date(original.endDate) : null);
			const timeInMinutes = endDate && startDate ? Math.round((endDate.getTime() - startDate.getTime()) / 60000) : original.timeInMinutes;
			this.staffAttendanceService.updateSingleById(change.key, { endDate, startDate, timeInMinutes })
				.subscribe(
					() => {
						this.toastService.success("Attendance record updated");
						this.getAttendance(this.item.id);
					},
					(err) => {
						console.log(err);
						this.toastService.error("Something Went Wrong!");
					}
				);
		}
	}

	setAvatarStyle(imageUrl: string) {
		this.avatarStyle = `background-image: url("${imageUrl}")`;
	}

	// A hover card on the band: the browser's own title tip takes a second to appear and cannot be styled.
	showMachineTimeTip(bar: any, event: MouseEvent) {
		const box = (event.target as HTMLElement).getBoundingClientRect();
		this.machineTimeTip = {
			...bar,
			x: Math.max(8, Math.min(window.innerWidth - 240, box.left + box.width / 2 - 110)),
			y: box.top - 8
		};
	}

	toggleUserGroup(e: any) {
		if (this.isSuperAdmin === false) {
			return;
		}

		this.userService.toggleGroup(this.item.userId, e.row.data.id)
			.subscribe(
				() => {
					const index = this.groups.findIndex((g => g.id === e.row.data.id));
					this.groups[index].isSelected = !this.groups[index].isSelected;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	updateItem() {
		this.itemService.updateSingleById(this.item.id, this.item)
			.subscribe(
				() => this.toastService.success("Successfully Updated "),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	updateTimeReport() {
		this.getTimeReport();
		this.closePopup();
	}

	updateTimeReportPopup() {
		this.popupAddButtonOptions = { onClick: () => this.updateTimeReport(), text: "Fetch Report" };
		this.popupCloseButtonOptions = { onClick: () => this.closePopup(), text: "Close" };
		this.popupTitle = "Time Report Parameters";
		this.popupVisible = true;
	}
	
	uploadProfileImage(file: File) {
		const containerName = "avatars";
		const uploadData = new FormData();
		uploadData.append("containerName", containerName);
		uploadData.append("files", file);
		uploadData.append("mimeTypeKey", "ImageMimeTypes");
		this.fileService.uploadFile(uploadData)
			.subscribe(
				(res: any) => {
					this.item.profileImage = `${environment.server.storageUrl}/${containerName}/${res.response[0].location}`;
					this.setAvatarStyle(this.item.profileImage);
					this.toastService.success("Image uploaded - Click Save to confirm change");
				},
				(err) => {
					console.log(err);
					this.toastService.error("Image Upload Failed - Please ensure you are uploading a valid image file");
				}
			);
	}

	viewBadgeIdPopup() {
		this.popupAddButtonOptions = { onClick: () => this.copyBadgeId(), text: "Copy" };
		this.popupCloseButtonOptions = { onClick: () => this.closePopup(), text: "Close" };
		this.popupTitle = "Badge ID";
		this.popupVisible = true;
	}
}